import { apiService } from '../services/api';
import { buildApiUrl } from './config';

/**
 * Scans HTML content for remaining base64 image src attributes,
 * uploads each to blob storage, and replaces with serving URLs.
 * Call before saving article content to catch images from rich HTML paste.
 */
export async function extractAndUploadBase64Images(
  htmlContent: string,
  organizationId?: string
): Promise<string> {
  const base64Regex = /src="(data:(image\/[^;]+);base64,[^"]+)"/g;
  const matches = [...htmlContent.matchAll(base64Regex)];

  if (matches.length === 0) return htmlContent;

  let result = htmlContent;

  for (const match of matches) {
    const fullDataUrl = match[1];
    const contentType = match[2];

    try {
      const response = await fetch(fullDataUrl);
      const blob = await response.blob();
      const ext = contentType.split('/')[1]?.replace('+xml', '') || 'png';
      const file = new File([blob], `pasted-image.${ext}`, { type: contentType });

      const uploadResponse = await apiService.uploadArticleImage(file, organizationId);
      if (uploadResponse.success && uploadResponse.data) {
        result = result.replace(fullDataUrl, buildApiUrl(`articles/images/${uploadResponse.data.id}`));
      }
    } catch (err) {
      console.error('Failed to extract and upload base64 image:', err);
      // Leave base64 in place — server accepts it within the 500K limit
    }
  }

  return result;
}
